import axios from 'axios';

export const getters = {};

export const mutations = {};

export const actions = {
    index() {
        return axios.$get('/accounts');
    },

    checkOtp(vuexContext, otp_code) {
        return axios.$post('accounts/two_factor_authentications', otp_code);
    },

    mcpSandboxSignup(vuexContext, email) {
        return axios.$post('/v1/accounts/mcp_sandbox_signup', { email });
    }
};
